// extracted by mini-css-extract-plugin
export default {"fullScreenLoader":"screenLoader_fullScreenLoader__MS+S-"};